import { useEffect } from 'react'

import { useRequest } from 'ahooks'

import { KindDetail } from '@eastcoal/api/system/interface'
import { queryKindTreeApi } from '@eastcoal/api/system/kind/queryKindTree'

import { KeySet } from '@eastcoal/common/types/utilities'

import { useKindAllNodeStringStoreApi } from '../hooks/useStore'
import { KindAllNodeStringState } from '../store/interface'

import { KindAllNodeStringStoreUpdaterProps } from './interface'

const useStoreUpdater = <M, K extends KeySet<KindAllNodeStringState<M>>>(
  key: K,
  value: KindAllNodeStringState<M>[K]
) => {
  const { setState } = useKindAllNodeStringStoreApi()

  useEffect(() => {
    setState({ [key]: value })
  }, [key, value, setState])
}

const EMPTY_ARRAY: KindDetail[] = []

export const KindAllNodeStringStoreUpdater = <M>({
  multiple,
  value,
  onChange
}: KindAllNodeStringStoreUpdaterProps<M>) => {
  const {
    data = EMPTY_ARRAY,
    error,
    loading,
    refreshAsync
  } = useRequest(queryKindTreeApi, {
    manual: false,
    defaultParams: [
      {
        enable: true
      }
    ]
  })

  useStoreUpdater('data', data)
  useStoreUpdater('error', error)
  useStoreUpdater('loading', loading)
  useStoreUpdater('reload', refreshAsync)

  useStoreUpdater('multiple', multiple)
  useStoreUpdater<M, 'onChange'>('onChange', onChange)

  useStoreUpdater<M, 'value'>('value', value)

  return null
}
